import styled from "styled-components";

export const AddTaskIcon = styled.svg`
  width: 31px;
  height: 31px;

  @media (min-width: 428px) {
    width: 34px;
    height: 34px;
  }

  @media (min-width: 744px) {
    width: 32px;
    height: 32px;
  }

  @media (min-width: 1440px) {
    width: 40px;
    height: 40px;
  }
`;

export const EditingTaskIcon = styled.svg`
  width: 13px;
  height: 13px;

  @media (min-width: 428px) {
    width: 16px;
    height: 16px;
  }

  @media (min-width: 744px) {
    width: 20px;
    height: 20px;
  }
`;

export const DeleteTaskIcon = styled.svg`
  width: 16px;
  height: 16px;

  @media (min-width: 428px) {
    width: 16px;
    height: 16px;
  }

  @media (min-width: 744px) {
    width: 20px;
    height: 20px;
  }
`;

export const SearchTaskIcon = styled.svg`
  width: 20px;
  height: 20px;

  @media (min-width: 744px) {
    width: 24px;
    height: 24px;
  }

  @media (min-width: 1440px) {
    width: 38px;
    height: 38px;
  }
`;

export const DownloadButtonIcon = styled.svg`
  width: 13px;
  height: 13px;

  @media (min-width: 428px) {
    width: 18px;
    height: 18px;
  }

  @media (min-width: 744px) {
    width: 20px;
    height: 20px;
  }
`;

export const CloseButtonModelIcon = styled.svg`
  width: 20px;
  height: 20px;
  fill: #fff;

  @media (min-width: 1440px) {
    width: 30px;
    height: 30px;
  }
`;

export const NotificationOnIconApp = styled.svg`
  width: 20px;
  height: 20px;

  @media (min-width: 428px) {
    width: 18px;
    height: 18px;
  }

  @media (min-width: 744px) {
    width: 20px;
    height: 20px;
  }

  @media (min-width: 1024px) {
    width: 25px;
    height: 25px;
  }

  @media (min-width: 1440px) {
    width: 30px;
    height: 30px;
  }
`;

export const NotificationOffIconApp = styled.svg`
  width: 20px;
  height: 20px;

  @media (min-width: 428px) {
    width: 18px;
    height: 18px;
  }

  @media (min-width: 744px) {
    width: 20px;
    height: 20px;
  }

  @media (min-width: 1024px) {
    width: 25px;
    height: 25px;
  }

  @media (min-width: 1440px) {
    width: 30px;
    height: 30px;
  }
`;

export const NotificationOnIconAppCard = styled.svg`
  width: 16px;
  height: 16px;

  @media (min-width: 428px) {
    width: 18px;
    height: 18px;
  }

  @media (min-width: 744px) {
    width: 20px;
    height: 20px;
  }

  @media (min-width: 1024px) {
    width: 25px;
    height: 25px;
  }
`;

export const NotificationOffIconAppCard = styled.svg`
  width: 13px;
  height: 13px;

  @media (min-width: 428px) {
    width: 18px;
    height: 18px;
  }

  @media (min-width: 744px) {
    width: 20px;
    height: 20px;
  }

  @media (min-width: 1024px) {
    width: 25px;
    height: 25px;
  }
`;
